import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { PublicMobileMenu } from '@/components/PublicMobileMenu';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SEMESTER_FEATURES = [
  'الوصول لجميع الدروس والمواد',
  'أدوات الذكاء الاصطناعي التعليمية',
  'دليل تدريس ذكي لكل درس',
  'أوراق عمل واختبارات تفاعلية',
  'حل الأسئلة بالصورة',
  'قصص مصورة للصفوف الأولى',
];
const PREMIUM_FEATURES = [
  'جميع مميزات الاشتراك الفصلي',
  'مدرس خصوصي ذكي للغة الإنجليزية',
  "تعلّم المحادثة والقواعد بالذكاء الاصطناعي",
  'تمارين تفاعلية مخصصة لمستوى الطالب',
  'متابعة تقدم الطالب في الإنجليزية',
];
const BANKS = [
  { name: 'بنك فلسطين', no: '0447-03035970' },
  { name: 'البنك الإسلامي الفلسطيني', no: '150-3399', pp: true },
];

// animated count-up number
const CountUp = ({ to }) => {
  const [v, setV] = useState(0);
  useEffect(() => {
    let raf, start;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / 1200, 1);
      setV(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [to]);
  return <>{v}</>;
};

const SubscribePage = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '' });
  const [file, setFile] = useState(null);
  const [bad, setBad] = useState({});
  const [err, setErr] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [copied, setCopied] = useState('');
  const fileRef = useRef(null);

  const openForm = () => {
    setForm({ name: '', phone: '' }); setFile(null); setBad({}); setErr(''); setSent(false); setOpen(true);
  };

  const copy = (v) => {
    try { navigator.clipboard.writeText(v); } catch (e) { /* noop */ }
    setCopied(v); setTimeout(() => setCopied(''), 1600);
  };

  const submit = async () => {
    const b = {};
    if (!form.name.trim()) b.name = true;
    if (!/^[0-9+\s-]{9,15}$/.test(form.phone.trim())) b.phone = true;
    if (!file) b.file = true;
    setBad(b);
    if (Object.keys(b).length) { setErr('يرجى تعبئة الاسم والجوال وإرفاق وصل الدفع'); return; }
    if (file.size > 5 * 1024 * 1024) { setErr('حجم الملف كبير جداً. الحد الأقصى 5 ميجابايت'); return; }
    setErr(''); setSending(true);
    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        await axios.post(`${API_URL}/api/subscribe`, {
          name: form.name, phone: form.phone, receipt_base64: reader.result, plan: 'الاشتراك الفصلي',
        });
        setSent(true);
      } catch {
        toast.error('حدث خطأ، حاول مرة أخرى');
      } finally { setSending(false); }
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="subpage" dir="rtl">
      {/* Header matching the provided design */}
      <header className="nav public-page-header" data-testid="public-page-header">
        <Link to="/" className="logo" data-testid="logo-link">RasheedGPT</Link>
        <ul className="public-desktop-navigation" data-testid="public-desktop-navigation">
          <li><Link to="/" data-testid="public-desktop-link-home">الرئيسية</Link></li>
          <li><Link to="/founder" data-testid="public-desktop-link-founder">المؤسس</Link></li>
          <li><Link to="/how-it-works" data-testid="public-desktop-link-how-it-works">كيف يعمل</Link></li>
          <li><Link to="/subscribe" className="cur" aria-current="page" data-testid="subscribe-nav-active">اشترك معنا</Link></li>
          <li><Link to="/feedback" data-testid="public-desktop-link-feedback">رأيك يهمنا</Link></li>
          <li><Link to="/login" className="lg" data-testid="public-desktop-link-login">تسجيل الدخول</Link></li>
        </ul>
        <Link to="/login" className="lmob" data-testid="mobile-login-btn">تسجيل الدخول</Link>
        <PublicMobileMenu />
      </header>

      <div className="rings" aria-hidden="true"><i></i><i></i><i></i></div>

      <main data-testid="subscribe-page">
        <div className="hd">
          <span className="badge">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1l11 11-11 11L1 12z" /></svg>
            اشترك الآن
          </span>
          <h1><span className="pk">اختر الخطة</span> المناسبة لك</h1>
          <p>استثمر في تعليم أبنائك مع أدوات الذكاء الاصطناعي التعليمية الأكثر تطوراً</p>
        </div>

        <div className="gr">
          {/* Featured */}
          <article className="pl ft" style={{ '--i': 0 }} data-testid="plan-semester">
            <span className="tag">الأكثر طلباً</span>
            <h2>الاشتراك الفصلي</h2>
            <div className="pr"><b><CountUp to={20} /></b><span>شيكل /<br />للفصل الدراسي الواحد</span></div>
            <ul className="fs">{SEMESTER_FEATURES.map((f, i) => <li key={i}>{f}</li>)}</ul>
            <button className="btn" onClick={openForm} data-testid="subscribe-now-btn">اشترك الآن</button>
          </article>

          {/* Coming soon */}
          <article className="pl so" style={{ '--i': 1 }} data-testid="plan-premium">
            <span className="tag so">قريباً</span>
            <h2>الاشتراك المميز</h2>
            <div className="pr"><b><CountUp to={200} /></b><span>شيكل /<br />للفصل الدراسي الواحد</span></div>
            <span className="chip">متاح فقط للصف الثامن والتاسع</span>
            <ul className="fs">{PREMIUM_FEATURES.map((f, i) => <li key={i}>{f}</li>)}</ul>
            <button className="btn" disabled>قريباً</button>
          </article>

          {/* Bank info */}
          <article className="pl bk" style={{ '--i': 2 }} data-testid="plan-bank">
            <h2>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10l9-6 9 6M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20h18" /></svg>
              طريقة الدفع - إيداع بنكي
            </h2>
            <p>قم بإيداع المبلغ في أحد الحسابات التالية، ثم أرفق وصل الدفع في نموذج الاشتراك وسنزودك ببيانات الدخول خلال 24 ساعة.</p>
            {BANKS.map((bk, i) => (
              <div key={i} className={`bc${bk.pp ? ' pp' : ''}`}>
                <small>{bk.name}</small>
                <div className="no">
                  <span>{bk.no}</span>
                  <button className="cp" onClick={() => copy(bk.no)} data-testid={`copy-bank-${i}`}>{copied === bk.no ? 'تم النسخ ✓' : 'نسخ'}</button>
                </div>
              </div>
            ))}
            <div className="hr">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
              بيانات الدخول خلال 24 ساعة
            </div>
          </article>
        </div>
      </main>

      {/* Subscription modal */}
      {open && (
        <div className="subov" onClick={(e) => { if (e.target.classList.contains('subov')) setOpen(false); }} data-testid="subscribe-modal">
          <div className="md" role="dialog" aria-modal="true">
            <aside className="sd">
              <small>خطتك</small>
              <h4>الاشتراك الفصلي</h4>
              <div className="pc">20<span>شيكل / للفصل الدراسي</span></div>
              <ol>
                <li><b>١</b>أودع المبلغ في أحد الحسابين البنكيين</li>
                <li><b>٢</b>أرفق وصل الدفع في النموذج</li>
                <li><b>٣</b>استلم بيانات الدخول خلال 24 ساعة</li>
              </ol>
            </aside>
            <div className="rt">
              <button className="x" onClick={() => setOpen(false)} aria-label="إغلاق" data-testid="close-modal-btn">✕</button>
              {sent ? (
                <div className="ok" data-testid="subscribe-success">
                  <div className="big"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg></div>
                  <h3>وصلنا طلبك، شكرًا لك!</h3>
                  <p className="s">سنزودك ببيانات الدخول خلال 24 ساعة.</p>
                </div>
              ) : (
                <div>
                  <h3>نموذج الاشتراك</h3>
                  <p className="s">املأ بياناتك وسنتواصل معك فورًا</p>

                  <label className="l" htmlFor="sub-a">
                    <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-7 8-7s8 3 8 7" /></svg>الاسم
                  </label>
                  <input id="sub-a" type="text" className={bad.name ? 'bad' : ''} value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} placeholder="أدخل اسمك" data-testid="subscribe-name-input" />

                  <label className="l" htmlFor="sub-b">
                    <svg viewBox="0 0 24 24"><path d="M5 3h4l2 5-2.5 1.5a11 11 0 005 5L15 12l5 2v4a2 2 0 01-2 2A16 16 0 013 5a2 2 0 012-2z" /></svg>رقم الجوال
                  </label>
                  <input id="sub-b" type="tel" dir="ltr" style={{ textAlign: 'right' }} className={bad.phone ? 'bad' : ''} value={form.phone} onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))} placeholder="05XXXXXXXX" data-testid="subscribe-phone-input" />

                  <label className="l" htmlFor="sub-f">
                    <svg viewBox="0 0 24 24"><path d="M21 12l-9 9a5 5 0 01-7-7l9-9a3.5 3.5 0 015 5l-9 9a2 2 0 01-3-3l8-8" /></svg>وصل الدفع
                  </label>
                  <input ref={fileRef} id="sub-f" type="file" accept="image/*,.pdf" style={{ position: 'absolute', opacity: 0, width: 1, height: 1 }} onChange={(e) => setFile(e.target.files[0] || null)} data-testid="subscribe-file-input" />
                  <label className={`dz${file ? ' has' : ''}${bad.file ? ' bad' : ''}`} htmlFor="sub-f">
                    <span className="ic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12l-9 9a5 5 0 01-7-7l9-9a3.5 3.5 0 015 5l-9 9a2 2 0 01-3-3l8-8" /></svg></span>
                    <span>{file ? `✓ ${file.name}` : 'اضغط لإرفاق صورة أو ملف PDF'}</span>
                  </label>

                  <div className="er" data-testid="subscribe-error">{err}</div>
                  <button className="btn" onClick={submit} disabled={sending} data-testid="subscribe-submit-btn">
                    {sending ? 'جارٍ الإرسال...' : 'إرسال الطلب'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscribePage;
